import { getUserFromSession } from "@onesolution/utils";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	beforeLoad: async () => {
		const user = await getUserFromSession();

		if (!user || !user?.isAuthenticated) {
			throw redirect({ to: "/login" });
		}

		throw redirect({ to: "/app", replace: true });
	},
});
